import { render, staticRenderFns } from "./CriterionTagSelector.vue?vue&type=template&id=77892648"
import script from "./CriterionTagSelector.vue?vue&type=script&lang=js"
export * from "./CriterionTagSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports